import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { createOrGetFetchedState } from '../../../../utils/fetched-data/create-or-get-fetched-state';
import { getCacheDuration } from '../../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../../utils/load-data-from-api';
import { orderDomainStore } from '../../store';
import { assignOrderRelatedData } from '../../utils/assign-order-related-data';
/**
 * Loads a [[CompletedOrder]] by its unique identifier.
 */
export const loadCompletedOrderById = async (orderId, reloadCachedData) => {
    const state = createOrGetFetchedState(orderDomainStore.data.completedOrdersById, orderId);
    return await loadDataFromApi({
        api: () => ocapiClient.instance.v1.orders.completed.getById(orderId),
        state,
        cacheDuration: getCacheDuration('orders'),
        onSuccess,
        reloadCachedData
    });
};
const onSuccess = (response, cacheDuration) => {
    const { order, relatedData } = response;
    assignOrderRelatedData(relatedData, cacheDuration);
    return order;
};
